import SpacRisk from "../SpacRisk";

/** SPAC Risk only — the SPACs P&L page's "SPACs Risk" tab, without the other tabs. */
export default function SPAC_Risk() {
  return <SpacRisk />;
}
